{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "properties": {},
      "geometry": {
        "coordinates": [
          [
            [
              54.13928458575509,
              24.57472893194931
            ],
            [
              54.13928458575509,
              24.207542954882683
            ],
            [
              54.75034039843399,
              24.207542954882683
            ],
            [
              54.75034039843399,
              24.57472893194931
            ],
            [
              54.13928458575509,
              24.57472893194931
            ]
          ]
        ],
        "type": "Polygon"
      }
    }
  ]
}